import React, { useState } from "react";

const GoalBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="w-full px-2 py-2 streak-banner mt-2 mb-2 relative">
      <button
        onClick={() => setIsVisible(false)}
        className="absolute top-2 right-2 w-4 h-4"
      >
        <img
          className="h-4 w-4"
          alt=""
          src={require("../../assets/close.png")}
        />
      </button>

      {/* Icon Box */}
        <div className="flex items-center justify-center mt-1">
          <img src={require("../../assets/streak.png")} alt=""  className="" />
          <p className="inter-regular-12 pr-5">
        <span className="inter-12-bold">GOAL- </span>Aim to balance your points across all 4 pillars! Every challenge you do = more points + an investment in yourself.
      </p>
        </div>

      
    </div>
  );
};

export default GoalBanner;
